import i18n from '@/locales/i18n';

const state = {
  appMode: 'DEV',
  language: i18n.locale,
  languages: Object.keys(i18n.messages),
  demo: false,
  sideNavOpen: false,
  errorId: null,
};

export default state;
